import React, { useEffect, useState, useRef } from "react";
import { Calendar } from 'primereact/calendar';
import { Dropdown } from 'primereact/dropdown';
import '../menu.css'
import { Ripple } from "primereact/ripple";
import { LoginResponse } from "../../../models/index";
import { wglcsApiService } from "../../../services/WglcsApiService";
import _ from "lodash";
import moment from "moment";
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column'
import { Skeleton } from "primereact/skeleton";
import { FilterMatchMode, FilterOperator } from 'primereact/api';
import * as XLSX from 'xlsx';
import { ProgressSpinner } from "primereact/progressspinner";
import jsPDF from 'jspdf'
import 'jspdf-autotable'
import html2canvas from 'html2canvas';
import EventEmitter, { Events } from "../../../services/eventemitter";
import { DetectEnvironment } from "../../../EnvironmentSettings";
import { t } from "i18next";
import ReactHTMLTableToExcel from 'react-html-table-to-excel';

const MultipleMonthlyAccSummary = () => {
    const tableRef = useRef(null);
    var userData = JSON.parse(localStorage.getItem("USER_DATA")!) as LoginResponse
    const fDate = new Date();
    fDate.setDate(1); // Set to the first day of the month
    const [fromDate, setFromDate] = useState<any>(fDate);
    const [toDate, setToDate] = useState<any>(new Date());
    const [selectedCompanyName, setSelectedCompanyName] = useState<any>(null);
    const [selectedWebsite, setSelectedWebsite] = useState<any>(null);
    const [selectedTimeZone, setSelectedTimeZone] = useState<any>(null);
    const [loadingCompanies, setLoadingCompanies] = useState(true)
    const [CompanyArray, setCompanyArray] = useState([])
    const [WebsiteArray, setWebsiteArray] = useState<any>([])
    const [TimeArray, setTimeArray] = useState<any>([])
    const [searchText, setSearchText] = useState("")
    const [multiMASData, setMultiMASData] = useState<any>([])
    const [loading, setLoading] = useState(false)
    const [timeloading, setTimeLoading] = useState(true)
    const [defaultTime, setDefaultTime] = useState<any>(null);
    const timeZoneRef = useRef<any>(null);
    const CompanyRef = useRef<any>(null);
    const [exportloading, setExportLoading] = useState(false)
    const [hidebutton, setHideButton] = useState(true)
    const skeletonLength = [
        { name: "" },
        { name: "" },
        { name: "" },
        { name: "" },
        { name: "" },
        { name: "" },
    ]
    const [filters, setFilters] = useState({
        'global': { value: null, matchMode: FilterMatchMode.CONTAINS }
    });
    useEffect(() => {
        ApiCalls()
    }, [])

    useEffect(() => {
        timeZone()
    }, [selectedWebsite])

    const ApiCalls = async () => {
        loadCompanies()
        timeZone()
    };
    const loadCompanies = async () => {
        let apiResponse = await wglcsApiService.getallCompaniesbyEmployeeCompanyid(userData?.userLoginData?.empCompId.toString());
        var arr = _.orderBy(apiResponse?.data?.data, ["companyName"], ["asc"]);
        setCompanyArray(arr as any)
        setLoadingCompanies(false)
    };
    const timeZone = async () => {
        let apiResponse = await wglcsApiService.GetAllReportingTimeZones();
        if (apiResponse) {
            setTimeLoading(false)
            if (selectedWebsite != null) {
                var data = apiResponse.data.filter(m => m.standardName == selectedWebsite.timeZone)
                if (data.length > 0) {
                    setTimeArray(apiResponse.data)
                    setSelectedTimeZone(data[0])
                    setDefaultTime(data[0])
                } else {
                    var data = apiResponse.data.filter(m => m.standardName === "Pakistan Standard Time")
                    setTimeArray(apiResponse.data)
                    setSelectedTimeZone(data[0])
                    setDefaultTime(data[0])
                }
            }
            else {
                var data = apiResponse.data.filter(m => m.standardName === "Pakistan Standard Time")
                setTimeArray(apiResponse.data)
                setSelectedTimeZone(data[0])
                setDefaultTime(data[0])
            }
        }
    }
    const onTimeChange = (e) => {
        setSelectedTimeZone(e.value);
    }
    const commonRequestData = () => {
        return {
            fromDate: moment(fromDate).format("YYYY-MM-DD"),
            toDate: moment(toDate).format("YYYY-MM-DD"),
            companyId: selectedCompanyName?.companyId,
            websiteId: selectedWebsite?.websiteId,
            timeZone: selectedTimeZone?.standardName,
            timeType: "",
            agentId: 0,
            chatCountBy: "",
            timeFrom: "",
            timeTo: "",
            region: "",
        };
    };
    const fromData = (e) => {
        setFromDate(e.value)
    }
    const toData = (e) => {
        setToDate(e.value)
    }
    const searchClear = () => {
        setSearchText("")
        setFilters({
            'global': { value: null, matchMode: FilterMatchMode.CONTAINS }
        })
    }
    const handleSearch = (e) => {
        const value = e.target.value;
        let _filters1 = { ...filters };
        _filters1['global'].value = value;
        setFilters(_filters1);
        setSearchText(value)
    }

    const MMAS = async () => {
        var result = await wglcsApiService.multiplemonthlyaccountsummaryreport(commonRequestData())
        setMultiMASData(result.data.data)
        setLoading(false)
    }
    const submit = () => {
        if (!selectedCompanyName) {
            EventEmitter.emit(Events.DisplayApiErrorResponse, t('toast.Company-validation'))
            return;
        }
        else {
            setLoading(true)
            MMAS()
            setHideButton(false)
        }
    }
    const onCompanyChange = (e) => {
        setSelectedCompanyName(e.value);
        loadWebsites(e.value.companyId);
    }
    const onWebsiteChange = (e) => {
        setSelectedWebsite(e.value);
        timeZoneRef?.current.resetFilter();
    }
    const loadWebsites = async (id) => {
        let response = await wglcsApiService.getwebsitebycompanyId(id);
        var data = response.data.data.filter(m => m.status === true)
        setWebsiteArray(data)
        setSelectedWebsite(data[0])
    };
    const CompanyOptionTemplate = (option) => {
        if (loadingCompanies) {
            return (
                <div style={{ margin: "2px" }} >
                    <Skeleton ></Skeleton>
                </div>
            );
        }
        if (option) {
            return (
                <div className="country-item">
                    <div>{option.companyName}</div>
                </div>
            );
        }
    };
    const renderSearchField = () => {
        return (
            <div className="search-view">
                <input
                    className="searchfeild"
                    value={searchText}
                    onChange={handleSearch}
                    placeholder={t("Search")}
                />
                <i className="fa-light fa-search search-icon"></i>
                {searchText.length > 0 && <i onClick={searchClear} className="fa fa-times clear-icon"></i>}
            </div>
        )
    }
    const ExportPDF = async () => {
        setExportLoading(true)
        const element = document.getElementById('reportContent');
        if (element) {
            const pdf = new jsPDF();

            // Add the image to the PDF
            const logoWidth = 45;
            const logoHeight = 15;
            const logoY = 5;
            const pdfWidth = pdf.internal.pageSize.getWidth();
            const centerX = (pdfWidth - logoWidth) / 2;

            const imageElement = document.getElementById('logoImage');
            const imgDataUrl = imageElement?.getAttribute('src') || ''; // Get the image source URL
            const canvas = document.createElement('canvas');
            const ctx = canvas.getContext('2d');

            if (ctx) {
                // Draw the image onto the canvas
                const img = new Image();
                img.src = imgDataUrl;
                await new Promise(resolve => {
                    img.onload = () => {
                        ctx.drawImage(img, 0, 0, canvas.width, canvas.height);
                        resolve(null);
                    };
                });

                // Add the HTML content to the PDF
                const canvasContent = await html2canvas(element);
                const imgContentData = canvasContent.toDataURL('image/png');
                pdf.addImage(imgContentData, 'PNG', 5, 30, 200, 80);

                // Add the logo image to the PDF
                const imgData = canvas.toDataURL('image/svg');
                pdf.addImage(imgData, 'SVG', centerX, logoY, logoWidth, logoHeight);

                pdf.save('Multiple Monthly Account Summary.pdf');
            }
        }
        setExportLoading(false)
    };
    const ExportExcel = () => {
        const table1 = [
            {
                A: "Month",
                B: "Website Traffic",
                C: "Chats Initiated",
                D: "Total Billable Chats",
                E: "Chat To Traffic Ratio",
                F: "Chat To Billable Ratio",
                G: "Avg Chat Duration",
                H: "Avg Chat Response"
            },
        ];
        let response
        let data = multiMASData
        if (data == '') {
        }
        else {
            response = data.map((d) => {
                table1.push({
                    A: d.month,
                    B: d.websiteTraffic,
                    C: d.chatsInitiated,
                    D: d.totalBillableChats,
                    E: TrafficRatio_Template(d),
                    F: BillableRatio_Template(d),
                    G: ChatDuration_Template(d),
                    H: d.avgChatResponse
                })
                return table1
            })
        }
        let table = [{}]
            .concat([{ A: "", B: "", C: "Multiple Monthly Account Summary" }])
            .concat([{ A: "", B: "", C: exportSelectedWebsite() }])
            .concat([""] as any)
            .concat(table1)
        const finalData = [...table]
        const workbook = XLSX.utils.book_new();
        const worksheet = XLSX.utils.json_to_sheet(finalData, { skipHeader: true });

        // Set column widths (optional)
        const wscols = [
            { wch: 15 }, // Column A width
            { wch: 15 }, // Column B width
            { wch: 15 }, // Column C width
            { wch: 18 }, // Column D width
            { wch: 18 }, // Column E width
            { wch: 18 }, // Column F width
            { wch: 18 }, // Column G width
            { wch: 18 }, // Column H width
        ];
        worksheet['!cols'] = wscols;
        XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet1');
        const lastRowIndex = finalData.length - 1
        XLSX.utils.sheet_add_aoa(worksheet, [["TOTAL", exportWebsiteTrafficfooterTemplate(), exportChatsInitiatedfooterTemplate(), exporttotalChatfooterTemplate(), exportTrafficRatiofooterTemplate(), exportBillableRatiofooterTemplate(), exportDurationfooterTemplate(), exportResponsefooterTemplate()]], { origin: -1, skipHeader: true, originRowIndex: lastRowIndex } as any);
        // Save the workbook as an Excel file
        XLSX.writeFile(workbook, 'Multiple_Monthly_Account_Summary.xlsx')
    }
    const TimeTemplate = (option) => {
        if (timeloading) {
            return (
                <div style={{ margin: "2px" }}>
                    <Skeleton ></Skeleton>
                </div>
            );
        }
        if (option) {
            return (
                <div className="country-item">
                    <div>{option.displayName}</div>
                </div>
            );
        }
    };
    const exportSelectedWebsite = () => {
        if (selectedWebsite) {
            return selectedWebsite?.domainName + " " + "(" + t('From') + ":" + moment(fromDate).format("MM-DD-YYYY") + " " + t("To") + ":" + moment(toDate).format("MM-DD-YYYY") + ")"
        } else {
            return ""
        }
    }
    const TrafficRatiofooterTemplate = () => {
        let total = 0;
        let WebsiteTraffic = 0
        let Chatinitiated = 0
        multiMASData?.forEach((item) => {
            WebsiteTraffic += parseFloat(item.websiteTraffic);
        });
        multiMASData?.forEach((item) => {
            Chatinitiated += parseFloat(item.chatsInitiated)
        });
        total = (Chatinitiated / WebsiteTraffic) * 100
        return (<div>
            <span style={{ fontSize: "12px" }}>{total ? total.toFixed(2) + "%" : 0}</span>
        </div>)
    }
    const exportTrafficRatiofooterTemplate = () => {
        let total = 0;
        let WebsiteTraffic = 0
        let Chatinitiated = 0
        multiMASData?.forEach((item) => {
            WebsiteTraffic += parseFloat(item.websiteTraffic);
        });
        multiMASData?.forEach((item) => {
            Chatinitiated += parseFloat(item.chatsInitiated)
        });
        total = (Chatinitiated / WebsiteTraffic) * 100
        return total ? total.toFixed(2) + "%" : 0
    }
    const BillableRatiofooterTemplate = () => {
        let total = 0;
        let Chatsinitiated = 0
        let totalbillablechats = 0
        multiMASData?.forEach((item) => {
            totalbillablechats += parseFloat(item.totalBillableChats);
            Chatsinitiated += parseFloat(item.chatsInitiated)
        });
        total = (totalbillablechats / Chatsinitiated) * 100
        return (<div>
            <span style={{ fontSize: "12px" }}>{total ? total.toFixed(2) + "%" : 0}</span>
        </div>)
    }
    const exportBillableRatiofooterTemplate = () => {
        let total = 0;
        let Chatsinitiated = 0
        let totalbillablechats = 0
        multiMASData?.forEach((item) => {
            totalbillablechats += parseFloat(item.totalBillableChats);
            Chatsinitiated += parseFloat(item.chatsInitiated)
        });
        total = (totalbillablechats / Chatsinitiated) * 100
        return total ? total.toFixed(2) + "%" : 0
    }
    const WebsiteTrafficfooterTemplate = () => {
        let total = 0;
        multiMASData.forEach((item) => {
            total += parseFloat(item.websiteTraffic);
        });
        return (<div >
            <span style={{ fontSize: "12px" }}>{total ? total : 0}</span>
        </div>)
    }
    const exportWebsiteTrafficfooterTemplate = () => {
        let total = 0;
        multiMASData.forEach((item) => {
            total += parseFloat(item.websiteTraffic);
        });
        return total ? total : 0
    }
    const ChatsInitiatedfooterTemplate = () => {
        let total = 0;
        multiMASData.forEach((item) => {
            total += parseFloat(item.chatsInitiated);
        });
        return (<div >
            <span style={{ fontSize: "12px" }}>{total ? total : 0}</span>
        </div>)
    }
    const totalChatfooterTemplate = () => {
        let total = 0;
        multiMASData.forEach((item) => {
            total += parseFloat(item.totalBillableChats);
        });
        return (<div >
            <span style={{ fontSize: "12px" }}>{total ? total : 0}</span>
        </div>)
    }
    const exportChatsInitiatedfooterTemplate = () => {
        let total = 0;
        multiMASData.forEach((item) => {
            total += parseFloat(item.chatsInitiated);
        });
        return total ? total : 0
    }
    const exporttotalChatfooterTemplate = () => {
        let total = 0;
        multiMASData.forEach((item) => {
            total += parseFloat(item.totalBillableChats);
        });
        return total ? total : 0
    }
    const ResponsefooterTemplate = () => {
        let total = 0;
        let avgChatResponse = 0
        multiMASData?.forEach((item) => {
            avgChatResponse += parseFloat(item.avgChatResponse)
        });
        var NoRows = multiMASData.length
        total = (avgChatResponse / NoRows)
        return (<div>
            <span style={{ fontSize: "12px" }}>{total ? total.toFixed(1) : 0}</span>
        </div>)
    }
    const exportResponsefooterTemplate = () => {
        let total = 0;
        let avgChatResponse = 0
        multiMASData?.forEach((item) => {
            avgChatResponse += parseFloat(item.avgChatResponse)
        });
        var NoRows = multiMASData.length
        total = (avgChatResponse / NoRows)
        return total ? total.toFixed(1) : 0
    }
    const DurationfooterTemplate = () => {
        let total = 0;
        let avgChatDuration = 0
        multiMASData?.forEach((item) => {
            avgChatDuration += parseFloat(item.avgChatDuration)
        });
        var NoRows = multiMASData.length
        total = (avgChatDuration / NoRows)
        let seconds = total;
        // Round off seconds to the nearest integer
        seconds = Math.round(seconds);
        // Calculate hours, minutes, and remaining seconds
        const hours = Math.floor(seconds / 3600);
        const minutes = Math.floor((seconds % 3600) / 60);
        const remainingSeconds = seconds % 60;
        // Convert to "00:00:00" format
        const formattedTime = `${hours < 10 ? '0' : ''}${hours}:${minutes < 10 ? '0' : ''}${minutes}:${remainingSeconds < 10 ? '0' : ''}${remainingSeconds}`;
        return (<div>
            <span style={{ fontSize: "12px" }}>{total ? formattedTime : 0}</span>
        </div>)
    }
    const exportDurationfooterTemplate = () => {
        let total = 0;
        let avgChatDuration = 0
        multiMASData?.forEach((item) => {
            avgChatDuration += parseFloat(item.avgChatDuration)
        });
        var NoRows = multiMASData.length
        total = (avgChatDuration / NoRows)
        let seconds = total;
        // Round off seconds to the nearest integer
        seconds = Math.round(seconds);
        // Calculate hours, minutes, and remaining seconds
        const hours = Math.floor(seconds / 3600);
        const minutes = Math.floor((seconds % 3600) / 60);
        const remainingSeconds = seconds % 60;
        // Convert to "00:00:00" format
        const formattedTime = `${hours < 10 ? '0' : ''}${hours}:${minutes < 10 ? '0' : ''}${minutes}:${remainingSeconds < 10 ? '0' : ''}${remainingSeconds}`;
        return total ? formattedTime : 0
    }
    const ChatDuration_Template = (rowData) => {
        let seconds = rowData.avgChatDuration;
        // Round off seconds to the nearest integer
        seconds = Math.round(seconds);
        // Calculate hours, minutes, and remaining seconds
        const hours = Math.floor(seconds / 3600);
        const minutes = Math.floor((seconds % 3600) / 60);
        const remainingSeconds = seconds % 60;
        // Convert to "00:00:00" format
        const formattedTime = `${hours < 10 ? '0' : ''}${hours}:${minutes < 10 ? '0' : ''}${minutes}:${remainingSeconds < 10 ? '0' : ''}${remainingSeconds}`;
        return formattedTime;
    }
    const TrafficRatio_Template = (rowData) => {
        return rowData.chatToTrafficRatio + "%";
    }
    const BillableRatio_Template = (rowData) => {
        return rowData.chatToBillableRatio + "%";
    }
    const renderLoader = () => {
        return (
          
                <ProgressSpinner strokeWidth="3" fill="#EEEEEE"  animationDuration=".5s" />
           
        );
    }
    return (
        <> <img id="logoImage" src={process.env.PUBLIC_URL + "/image/" + DetectEnvironment.config.REACT_APP_LOGO} alt="" style={{ display: 'none' }} />
            <div className="wgReoprts-container">
                <div className="row p-2">
                    <div className="wgreport-tab viewreport-box">
                        <div className="row view-wgreport ">
                            <div className="col-md-3 col-lg-3 py-1 wgreport" >
                                <label className="wgreport-label" htmlFor="firstname6">{t('smtp-DataTable.Company-Name')}</label>
                                <div className="spinner-box">
                                <Dropdown className="form-control"
                                    filter
                                    showFilterClear
                                    filterBy="companyName"
                                    value={selectedCompanyName}
                                    options={CompanyArray}
                                    onChange={onCompanyChange}
                                    optionLabel="companyName"
                                    placeholder={!loadingCompanies ? t('fieldsPlaceholder.selectCompany') : selectedCompanyName}
                                // itemTemplate={CompanyOptionTemplate}
                                // ref={CompanyRef}
                                />
                                {loadingCompanies && renderLoader()}
                                </div>
                            </div>
                            <div className="col-md-3 col-lg-3 py-1 wgreport" >
                                <label className="wgreport-label" htmlFor="basic">{t('MonitoringPanel 6erComponent.Website-Name')}</label>
                                <Dropdown className="form-control"
                                    filter
                                    showFilterClear
                                    filterBy="domainName"
                                    value={selectedWebsite}
                                    options={WebsiteArray}
                                    onChange={onWebsiteChange}
                                    optionLabel="domainName"
                                    placeholder={t('ReportComponent.Select Website')} />
                            </div>
                            <div className="col-md-3 col-lg-3 py-1 wgreport" >
                                <label className="wgreport-label" htmlFor="firstname6">{t('ChatTranscriptComponent.From Date')}</label>
                                <Calendar showIcon value={fromDate} onChange={(e) => fromData(e)}
                                    minDate={new Date(new Date().getFullYear(), new Date().getMonth() - 5, 1)}
                                    maxDate={new Date()}
                                />
                            </div>
                            <div className="col-md-3 col-lg-3 py-1 wgreport">
                                <label className="wgreport-label" htmlFor="basic">{t('ChatTranscriptComponent.To Date')}</label>
                                <Calendar id="abc" showIcon value={toDate} onChange={(e) => toData(e)}
                                    maxDate={new Date()}
                                    minDate={new Date(fromDate.getFullYear(), fromDate.getMonth(), 1)}
                                />
                            </div>
                            <div className="col-md-3 col-lg-3  py-1 wgreport">
                                <label className="wgreport-label" htmlFor="basic">{t('ManagePoc-DataTable.Time-Zone')}</label>
                                <div className="spinner-box">
                                <Dropdown className="form-control"
                                    filter
                                    showFilterClear
                                    filterBy="displayName"
                                    value={selectedTimeZone}
                                    options={TimeArray}
                                    onChange={onTimeChange}
                                    optionLabel="displayName"
                                    itemTemplate={TimeTemplate}
                                    placeholder={!timeloading ? t('ManagePoc-DataTable.Select-TimeZone') : selectedTimeZone}
                                />
                                {timeloading && renderLoader()}
                                </div>
                            </div>
                            <div className="col-md-9 py-1 text-right text-md-left">
                                {hidebutton == false ? <> <span title={t('wg-buttons.Export-Excel')}>
                                    <ReactHTMLTableToExcel
                                        id="test-table-xlsx-button search-btn"
                                        className="btn-width wgreport-btn wgbtn p-ripple"
                                        table="table-to-xlsx"
                                        filename={t('DashboardReports.MultipleMonthlyAccountSummary')}
                                        sheet={t('DashboardReports.MultipleMonthlyAccountSummary')}
                                        buttonText={t('wg-buttons.Export-Excel')}
                                    />
                                </span>
                                    <button title={t('wg-buttons.Export-PDF')} className="btn-width wgreport-btn wgbtn p-ripple" onClick={() => ExportPDF()}> <Ripple />{exportloading ?
                                        <ProgressSpinner
                                            style={{ width: "25px", bottom: "10px" }}
                                            strokeWidth="3"
                                            fill="#EEEEEE"
                                            animationDuration=".5s"
                                        /> : t('wg-buttons.Export-PDF')}</button>
                                </> : ""}
                                <button title={t('wg-buttons.View-Report')} className="btn-width wgreport-btn wgbtn p-ripple" onClick={() => submit()}> <Ripple />{t('wg-buttons.View-Report')}</button>
                            </div>
                        </div>
                    </div>
                </div>
                <div id="reportContent">
                    <div className="row">
                        <div className="col-12 text-center">
                            <div className="wgreport-span">{t('DashboardReports.MultipleMonthlyAccountSummary')}</div>
                            <div className="wgreport-span">{exportSelectedWebsite()}</div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-12">
                            {renderSearchField()}
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-12">
                            {loading == true ?
                                <ProgressSpinner
                                    style={{ width: "50px", marginLeft: "50%", marginTop: "10%" }}
                                    strokeWidth="3"
                                    fill="#EEEEEE"
                                    animationDuration=".5s"
                                /> :
                                <DataTable value={multiMASData} filterDisplay="menu"
                                    dataKey="id"
                                    emptyMessage={t('resourcesPoolTable.Data Not Found')} filters={filters}>
                                    <Column field="month" header={t('DashboardReport-dataTable.Month')} footer={t('DashboardReport-dataTable.Total')} sortable></Column>
                                    <Column field="websiteTraffic" header={t('DashboardReport-dataTable.Website-Traffic')} footer={WebsiteTrafficfooterTemplate} sortable></Column>
                                    <Column field="chatsInitiated" header={t('DashboardReport-dataTable.Chats-Initiated')} footer={ChatsInitiatedfooterTemplate} sortable></Column>
                                    <Column field="totalBillableChats" header={t('DashboardReport-dataTable.TotalBillable-Chats')} footer={totalChatfooterTemplate} sortable></Column>
                                    <Column body={TrafficRatio_Template} header={t('DashboardReport-dataTable.ChatTraffic-Ratio')} footer={TrafficRatiofooterTemplate} sortable></Column>
                                    <Column body={BillableRatio_Template} header={t('DashboardReport-dataTable.ChatBillable-Ratio')} footer={BillableRatiofooterTemplate} sortable></Column>
                                    <Column body={ChatDuration_Template} header={t('DashboardReport-dataTable.AvgChat-Duration')} footer={DurationfooterTemplate} sortable></Column>
                                    <Column field="avgChatResponse" header={t('DashboardReport-dataTable.AvgChat-Response')} footer={ResponsefooterTemplate} sortable></Column>
                                </DataTable>
                            }
                        </div>
                    </div>
                    <div className='htmltable' style={{ display: 'none' }}>
                        {multiMASData && <table id="table-to-xlsx" ref={tableRef}>
                            <thead>
                                <tr>
                                    <td>&nbsp;</td>
                                </tr>
                                <tr>
                                    <td>&nbsp;</td>
                                    <td style={{ fontSize: "18px", color: "black", textAlign: "center", fontWeight: 600 }} colSpan={9}>{t('DashboardReports.MultipleMonthlyAccountSummary')}</td>
                                </tr>
                                <tr>
                                    <td>&nbsp;</td>
                                    <th style={{ fontSize: "16px", color: "black", textAlign: "center", fontWeight: 400 }} colSpan={9}>{exportSelectedWebsite()}</th>                                </tr>
                                <tr>
                                    <td>&nbsp;</td>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <th>&nbsp;</th>
                                    <th style={{ background: "#84bdf3", border: "1px solid #000" }}>
                                        {t('DashboardReport-dataTable.Month')}
                                    </th>
                                    <th style={{ background: "#84bdf3", border: "1px solid #000" }}>
                                        {t('DashboardReport-dataTable.Website-Traffic')}
                                    </th>
                                    <th style={{ background: "#84bdf3", border: "1px solid #000" }}>
                                        {t('DashboardReport-dataTable.Chats-Initiated')}
                                    </th>
                                    <th style={{ background: "#84bdf3", border: "1px solid #000" }}>
                                        {t('DashboardReport-dataTable.TotalBillable-Chats')}
                                    </th>
                                    <th style={{ background: "#84bdf3", border: "1px solid #000" }}>
                                        {t('DashboardReport-dataTable.ChatTraffic-Ratio')}
                                    </th>
                                    <th style={{ background: "#84bdf3", border: "1px solid #000" }}>
                                        {t('DashboardReport-dataTable.ChatBillable-Ratio')}
                                    </th>
                                    <th style={{ background: "#84bdf3", border: "1px solid #000" }}>
                                        {t('DashboardReport-dataTable.AvgChat-Duration')}
                                    </th>
                                    <th style={{ background: "#84bdf3", border: "1px solid #000" }}>
                                        {t('DashboardReport-dataTable.AvgChat-Response')}
                                    </th>

                                </tr>
                                {multiMASData.map((item, index) => (
                                    <tr key={index}>
                                        <td>&nbsp;</td>
                                        <td style={{ textAlign: "center", border: "1px solid #000" }}>{item.month}</td>
                                        <td style={{ textAlign: "center", border: "1px solid #000" }}>{item.websiteTraffic}</td>
                                        <td style={{ textAlign: "center", border: "1px solid #000" }}>{item.chatsInitiated}</td>
                                        <td style={{ textAlign: "center", border: "1px solid #000" }}>{item.totalBillableChats}</td>
                                        <td style={{ textAlign: "center", border: "1px solid #000" }}>{TrafficRatio_Template(item)}</td>
                                        <td style={{ textAlign: "center", border: "1px solid #000" }}>{BillableRatio_Template(item)}</td>
                                        <td style={{ textAlign: "center", border: "1px solid #000" }}>{ChatDuration_Template(item)}</td>
                                        <td style={{ textAlign: "center", border: "1px solid #000" }}>{item.avgChatResponse}</td>
                                    </tr>
                                ))}
                            </tbody>
                            <tfoot>
                                {/* <tr>
                                    <td>&nbsp;</td>
                                </tr> */}
                                <tr>
                                    <td>&nbsp;</td>
                                    <th style={{ textAlign: "center", border: "1px solid #000" }}>TOTAL</th>
                                    <td style={{ textAlign: "center", border: "1px solid #000" }} > {WebsiteTrafficfooterTemplate()}</td>
                                    <td style={{ textAlign: "center", border: "1px solid #000" }}> {ChatsInitiatedfooterTemplate()}</td>
                                    <td style={{ textAlign: "center", border: "1px solid #000" }}> {totalChatfooterTemplate()}</td>
                                    <td style={{ textAlign: "center", border: "1px solid #000" }}>  {TrafficRatiofooterTemplate()}</td>
                                    <td style={{ textAlign: "center", border: "1px solid #000" }}> {BillableRatiofooterTemplate()}</td>
                                    <td style={{ textAlign: "center", border: "1px solid #000" }}>  {DurationfooterTemplate()}</td>
                                    <td style={{ textAlign: "center", border: "1px solid #000" }}> {ResponsefooterTemplate()}</td>
                                </tr>
                            </tfoot>
                        </table>}
                    </div>
                </div>
            </div>
        </>
    )
}
export default MultipleMonthlyAccSummary